import React from 'react';
import PropTypes from 'prop-types';

import { OneStepDepositDetails } from 'common/Notifications/Popups/OneStepDepositPopup/components/OneStepDepositDetails';
import SelfRegulationProvider from 'src/components/SelfRegulationProvider';

/**
 * One-Step Deposit popup shell (FT-8610).
 *
 * Renders the reusable @atlas/ui DepositPopup (header + scrollable content slot +
 * sticky Deposit footer). The popup body is intentionally empty here — payment
 * methods (FT-8612), amount field (FT-8616), adaptive chips (FT-8613) and the
 * deposit submit logic (FT-8611) are added by their own tasks.
 */

const OneStepDepositPopup = ({ id }) => {
  return (
    <SelfRegulationProvider>
      <OneStepDepositDetails id={id} />
    </SelfRegulationProvider>
  );
};

OneStepDepositPopup.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default OneStepDepositPopup;
